import styles from "./GeneralRecommendations.module.css";
import firstImage from "../../../../assets/images/pages/DiagnosticsMarathon/section-3-1-img.svg"
import firstBlockImage from "../../../../assets/images/pages/DiagnosticsMarathon/section-3-2-img.svg"
import secondBlockImage from "../../../../assets/images/pages/DiagnosticsMarathon/section-3-3-img.svg"
import thirdBlockImage from "../../../../assets/images/pages/DiagnosticsMarathon/section-3-4-img.svg"
import fourthBlockImage from "../../../../assets/images/pages/DiagnosticsMarathon/section-3-5-img.svg"

import { MyText } from "../../../common";
import { Col, Row } from "antd";

const CheckCircle = () => (
  <svg
    className={styles.listMarker}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <circle cx="10" cy="10" r="9" fill="#FF9500" stroke="#FF9500" strokeWidth="2" />
    <path d="M6 10L9 13L14 7" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const LEFT_ITEMS = [
  { text: "Если ребёнок набрал менее половины положительных ответов по возрасту, обратитесь к специалисту.", img: firstBlockImage },
  { text: "Своевременное выявление и коррекция задержек значительно повышают эффективность работы.", img: secondBlockImage },
  { text: "Развитие речи тесно связано с развитием слуха, моторики и внимания, важен комплексный подход.", img: thirdBlockImage },
  { text: "Используйте простые игры, чтение, активное общение для поддержки речевого развития.", img: fourthBlockImage },
] as const;


export const GeneralRecommendations = () => {
  return (
    <section className={styles.section} aria-label="Кому подойдёт марафон">
      <div className={styles.container}>
        <Row
  gutter={[32, 32]}
  className={styles.card}
>
  <Col span={14}>
    <Row gutter={[24, 24]}>
      <Col span={24} style={{marginBottom: 20}}>
        <MyText
          color="#0A033C"
          size={32}
          weight={800}
          style={{
            fontFamily: 'Nunito',
            display: 'block',
          }}
        >
          Общие рекомендации для родителей
        </MyText>
      </Col>

      {LEFT_ITEMS.map((item) => (
        <Col span={24} key={item.text}>
          <Row gutter={16} align="middle" wrap={false}>
            <Col>
              <img
                src={item.img}
                alt="second-section-image"
                style={{ maxWidth: 'unset' }}
              />
            </Col>

            <Col flex="auto">
              <MyText
                color="#364153"
                size={18}
                weight={400}
                style={{
                  fontFamily: 'Nunito',
                  display: 'block',
                }}
              >
                {item.text}
              </MyText>
            </Col>
          </Row>
        </Col>
      ))}
    </Row>
  </Col>

  <Col span={10}>
    <img
      src={firstImage}
      alt="section-3-image"
      className={styles.image}
    />
  </Col>
</Row>
      </div>
    </section>
  );
};